import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    phone: sessionStorage.getItem("phone") || ''
  },
  getters: {
    
  },
  mutations: {
    setPhone(state, phone) {
      state.phone = phone
      sessionStorage.setItem("phone", phone)
    }
  },
  actions: {

  }
})